module.exports = __webpack_public_path__ + "static/media/badcredit.633cdc7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/components/Press/images/badcredit.png
// module id = 892
// module chunks = 0